<template>
  <div v-loading.fullscreen.lock="loading">
    <vacation-category-search-bar-component
      add_auth="新增休假类型"
      @search="get_vacation_category_index"
      @addTeam="addTeam"
    ></vacation-category-search-bar-component>
    <common-table-component
      details_auth="休假类型详情"
      :col_arr="fcol_arr"
      :table_data="ftable_data"
      @details_row="details_vacation_category"
    ></common-table-component>
    <common-page-component
      :current_page="cond.page"
      :page_size="cond.limit"
      :total="ftotal"
      @search="get_vacation_category_index"
    ></common-page-component>
    <vacation-category-edit-component
      edit_auth="修改休假类型"
      del_auth="删除休假类型"
      :id="fid"
      :show_type="edit_type"
      :dialogFormVisible="fdialogFormVisible"
      :vacation_category_details_data="fvacation_category_details_data"
      @exitDialog="dialogExit"
      @search="get_vacation_category_index"
      @show_edit="show_edit"
      @details_row="details_vacation_category"
    ></vacation-category-edit-component>
  </div>
</template>

<script>
import {
  vacation_category_index_request,
  vacation_category_details_request,
} from "@/network/hrm/VacationCategory.js";

import VacationCategorySearchBarComponent from "@/components/hrm/VacationCategory/VacationCategorySearchBarComponent";
import CommonTableComponent from "@/components/common/CommonTableComponent";
import CommonPageComponent from "@/components/common/CommonPageComponent";
import VacationCategoryEditComponent from "@/components/hrm/VacationCategory/VacationCategoryEditComponent";

export default {
  name: "vacation_categoryView",
  data() {
    return {
      fid: 0,
      edit_type: 0,
      fdialogFormVisible: false,
      loading: false,
      ftotal: 0,
      cond: {
        name: "",
        page: 1,
        limit: 10,
      },
      ftable_data: [],
      fcol_arr: [
        {
          prop: "name",
          label: "类型名称",
          minWidth: "100px",
        },
        {
          prop: 'type',
          label: '休假类别',
          minWidth: '100px',
          tag: (d) => {
              if(d===0) {
                  return {
                      type: 'primary',
                      filter_data: '普通假'
                  }
              } else if(d===1) {
                  return {
                      type: 'warning',
                      filter_data: '特殊假'
                  }
              }
          }
        },
        {
          prop: "create_staff_name",
          label: "创建人",
          minWidth: "80px",
        },
        {
          prop: "create_time",
          label: "创建时间",
          minWidth: "80px",
        }
      ],
      fvacation_category_details_data: {},
    };
  },
  computed: {},
  methods: {
    // 添加信息（弹框）
    addTeam() {
      this.edit_type = 1;
      this.fdialogFormVisible = true;
    },
    // 修改（弹框）
    show_edit() {
      this.edit_type = 2;
    },
    get_vacation_category_index(param = {}) {
      this.loading = true;
      this.cond.name = param.name ?? this.cond.name;
      this.cond.page = param.page ?? this.cond.page;
      if (param.limit) {
        this.cond.limit = param.limit;
        this.cond.page = 1;
      }
      vacation_category_index_request(this.cond)
        .then((s) => {
          this.loading = false;
          if (s.status === 0) {
            this.ftable_data = s.result.data;
            this.ftotal = s.result.total;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    details_vacation_category(id) {
      this.fid = id;
      this.fdialogFormVisible = true;
      vacation_category_details_request(id)
        .then((s) => {
          if (s.status === 0) {
            this.fvacation_category_details_data = s.result;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogExit() {
      this.fdialogFormVisible = false;
      this.fid = 0;
      this.edit_type = 0;
    },
  },
  filters: {},
  props: {},
  created() {
    this.get_vacation_category_index();
  },
  destoryed() {},
  mounted() {},
  updated() {},
  components: {
    VacationCategorySearchBarComponent,
    CommonTableComponent,
    CommonPageComponent,
    VacationCategoryEditComponent,
  },
  watch: {},
};
</script>

<style lang="less"></style>
